import React, { PureComponent } from "react";
import { connect } from "react-redux";
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu/Menu';
import MenuItem from '@mui/material/MenuItem/MenuItem';
import { MoreVert as MoreVertIcon } from '@mui/icons-material';
import { Button, Modal, Loader, Text, Theme, BlockRow } from '@simplybenefits/sb-ui-library';
import * as dates from '@simplybenefits/sb-dates';
import { helpers } from '@simplybenefits/sb-utils';
import { downloadPredetermination, removePredetermination } from '../../../actions/adjudication.js';
import PermissionsComponent from '../../../components/PermissionsComponent.js';

class PredeterminationBlock extends PureComponent {
    state = {
        anchorEl: null,
        showRemoveModal: false
    };

    _handleMenuClick = (event) => {
        this.setState({ anchorEl: event.currentTarget });
    };

    _handleCloseMenu = () => {
        this.setState({ anchorEl: null });
    };

    _openModal = (type) => {
        this.setState({
            [type]: true,
            anchorEl: null
        });
    };

    _removePredetermination = () => {
        this.props.dispatch(removePredetermination(this.props.predeterminationID));
    };

    _downloadPredetermination = async () => {
        const summaryPDF = await this.props.dispatch(downloadPredetermination(this.props.predeterminationID));

        const linkSource = `data:application/pdf;base64,${ summaryPDF }`;
        const downloadLink = document.createElement("a");
        const fileName = `Simply_Predetermination_${ this.props.referenceNumber }.pdf`;

        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
    };

    _closeModal = () => {
        this.setState({
            showRemoveModal: false
        });
    };

    _handleInputChange = async (type, value) => {
        await this.setState({
            [type]: value
        });
    };

    render() {
        const { user, submitted = 0, claimed = 0, benefit, adjudicated = 0, predeterminationID, referenceNumber, submissionDate, isHeader, testid } = this.props;
        const styles = {
            headerBlockRow: {
                display: 'flex',
                flex: 1,
                alignItems: 'center',
                flexDirection: 'row',
                height: 30,
                marginBottom: 5
            },
            typeBlock: {
                display: 'flex',
                flex: 1,
                alignItems: 'flex-start',
                backgroundColor: Theme.colors.lightBlue,
                flexDirection: 'column',
                height: '100%',
                justifyContent: 'center',
                padding: "0 20px"
            },
            block: {
                display: 'flex',
                flex: 1,
                alignItems: 'center',
                flexDirection: 'row',
                justifyContent: 'flex-end'
            }
        };
        

        if (isHeader) {
            return (
                <div style={styles.headerBlockRow}>
                    <div style={ { ...styles.typeBlock, backgroundColor: Theme.colors.backgroundGrey, padding: "0 15px" } }>
                        <Text small>Type</Text>
                    </div>

                    <div style={styles.block}>
                        <Text small>Identifier</Text>
                    </div>

                    <div style={styles.block}>
                        <Text small>Reference Number</Text>
                    </div>

                    <div style={styles.block}>
                        <Text small>Submitted</Text>
                    </div>

                    <div style={styles.block}>
                        <Text small>Adjudicated</Text>
                    </div>

                    <div style={styles.block}>
                        <Text small>Claimed</Text>
                    </div>

                    <div style={styles.block}>
                        <Text small>Submission Date</Text>
                    </div>

                    {
                        this.props.access && this.props.access.toUpperCase() === 'MASTER' &&
                            <div style={{ ...styles.block, flex: 0.5 }} />
                    }
                </div>
            );
        }

        return (
            <React.Fragment>
                <BlockRow id={testid} style={{ cursor: 'initial' }}>
                    <div style={styles.typeBlock}>
                        <Text medium light>{ benefit }</Text>
                        <Text tiny>
                            { user }
                        </Text>
                    </div>

                    <div style={styles.block}>
                        <Text medium light>
                            { predeterminationID }
                        </Text>
                    </div>

                    <div style={styles.block}>
                        <Text medium light>
                            { referenceNumber }
                        </Text>
                    </div>

                    <div style={styles.block}>
                        <Text medium light>
                            { `$${ helpers.formatNumber(submitted) }` }
                        </Text>
                    </div>

                    <div style={styles.block}>
                        <Text medium light>
                            { `$${ helpers.formatNumber(adjudicated) }` }
                        </Text>
                    </div>

                    <div style={styles.block}>
                        <Text medium light>
                            { `$${ helpers.formatNumber(claimed) }` }
                        </Text>
                    </div>

                    <div style={styles.block}>
                        <Text medium light>
                            { dates.getLocalDisplay(submissionDate) }
                        </Text>
                    </div>

                    <div style={{ ...styles.block, flex: 0.5 }} >
                        <IconButton aria-label="Edit" onClick={this._handleMenuClick} sx={{ color: Theme.colors.mainTextGrey }}>
                            <MoreVertIcon />
                        </IconButton>

                        <Menu
                            anchorEl={this.state.anchorEl}
                            open={Boolean(this.state.anchorEl)}
                            onClose={this._handleCloseMenu}
                            disableAutoFocusItem={true}
                            style={styles.menu}
                        >
                            <MenuItem onClick={this._downloadPredetermination} >
                                <Text color="inherit" medium display="inline">
                                    Download Form
                                </Text>
                            </MenuItem>
                            <PermissionsComponent
                                permission="Remove Predetermination"
                                accessType={this.props.access}
                                level="write"
                            >
                                <MenuItem onClick={() => this._openModal('showRemoveModal')} >
                                    <Text color="inherit" medium display="inline">
                                        Remove
                                    </Text>
                                </MenuItem>
                            </PermissionsComponent>
                        </Menu>
                    </div>
                </BlockRow>

                <Modal
                    open={this.state.showRemoveModal}
                    onClose={this._closeModal}
                    title="Remove Predetermination"
                >
                    {
                        this.props.loader?.isLoading || this.props.masterLoading ?
                            <Loader isContainer/>
                            :
                            <div>
                                <Text
                                    align="left"
                                    medium
                                    display="inline-block"
                                    margin="10px 0"
                                >
                                    Are you sure you want to remove this Predetermination?
                                </Text>

                                <Button
                                    onClick={this._removePredetermination}
                                    marginTop={5}
                                    color="primary"
                                    fullWidth
                                >
                                    Remove Predetermination
                                </Button>
                            </div>
                    }
                </Modal>
            </React.Fragment>
        );
    }
}

/**
 *
 * @param {*} theme
 */

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loading: state.adjudication.loading,
    masterLoading: state.master.loading,
    access: state.master.access
});

export default connect(mapStateToProps)(PredeterminationBlock);